import { simpleSet } from '@r/reducers/utils';

export const importExportModalVisible = simpleSet<
    'SET_IMPORT_EXPORT_MODAL_VISIBLE',
    redux._IStore['modals']['importExportModalVisible']
  >( 'SET_IMPORT_EXPORT_MODAL_VISIBLE', false );
